
import {
    Menu, Accordion, AccordionDetails, AccordionSummary,
    FormGroup, FormControlLabel, IconButton, Button, Checkbox, TextField
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AppContext, AppAction } from "helpers/context";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/en"; // 导入中文语言包
import "dayjs/locale/zh"; // 导入中文语言包


interface FilterEventProps {
    anchorEl: any;
    handleClose: any;
}

function FilterEvents(props: FilterEventProps) {
    const [t] = useTranslation();
    const [context, dispatch] = useContext(AppContext);
    const [formData, setFormData] = useState<any>({
        ...context.eventsFilterForm,
        isNotRequest: false,
        fromDateTime: dayjs(context.eventsFilterForm.fromDateTime),
        toDateTime: dayjs(context.eventsFilterForm.toDateTime),

    });

    const [expanded, setExpanded] = useState(false);
    const open = Boolean(props.anchorEl);

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        if (name === "fromDateTime" || name === "toDateTime") {
            setFormData({ ...formData, [name]: value });
        } else if (name === "isShowAll") {
            setFormData({
                ...formData,
                fromDateTime: event.target.checked ? dayjs("1876-01-01") : dayjs(new Date().setMonth(new Date().getMonth() - 3)),
                [name]: event.target.checked
            });
        } else {

            let type = [...formData.type];

            if (type.includes(name)) {
                type = type.filter((item) => item !== name);
            } else {
                type.push(name);
            }
            setFormData({ ...formData, type: type });
        }
    }

    const handleSelectAll = (event: any) => {
        const { checked } = event.target;
        if (checked) {
            let type = [...formData.type];
            if (!type.includes("Cyclone")) {
                type.push("Cyclone");
            }
            if (!type.includes("Winterstorm")) {
                type.push("Winterstorm");
            }
            setFormData({ ...formData, type: type });
        } else {
            setFormData({ ...formData, type: formData.type.filter((item: any) => item !== "Cyclone" && item !== "Winterstorm") });
        }
    }

    const handleIndeterminate = () => {
        const { type } = formData;
        let num = 0;
        if (type.includes("Cyclone")) {
            num++;
        }
        if (type.includes("Winterstorm")) {
            num++;
        }

        return num === 1;
    }

    const handleRestDisable = () => {
        let fromDateTime = dayjs(new Date().setMonth(new Date().getMonth() - 3)).format("YYYY-MM-DD");
        let toDateTime = dayjs(new Date()).format("YYYY-MM-DD");
        if (fromDateTime === formData.fromDateTime.format("YYYY-MM-DD")
            && toDateTime === formData.toDateTime.format("YYYY-MM-DD")
            && !formData.isShowAll
            && formData.type.length === 5
        ) {
            return true;
        } else {
            return false;
        }
    }

    const handleApplyDisable = () => {
        let sortformDataArr = formData.type.sort();
        let sortEventsFilterFormArr = [...context.eventsFilterForm.type].sort((a, b) => a.localeCompare(b));
        if (formData.fromDateTime.format("YYYY-MM-DD") === context.eventsFilterForm.fromDateTime
            && formData.toDateTime.format("YYYY-MM-DD") === context.eventsFilterForm.toDateTime
            && formData.isShowAll === context.eventsFilterForm.isShowAll
            && JSON.stringify(sortformDataArr) === JSON.stringify(sortEventsFilterFormArr)
        ) {
            return true;
        } else {
            return false;
        }
    }

    return (<Menu
        anchorEl={props.anchorEl}
        open={open}
        onClose={props.handleClose}
        transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        sx={{
            "& .MuiList-root": {
                py: 0,
            }
        }}
    >
        <div className="card compact dropdown-content p-0 shadow w-[380px] rounded-[4px] overflow-hidden">
            <div className="text-[16px] m-[16px] h-[19px] font-medium text-[#000000de]">{t("events.filterEvents")}</div>
            <div className="p-[16px]">
                <div>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale={context.language === "cn" ? "zh" : "en"}

                    >
                        <DesktopDatePicker
                            label={t("userSystem.startDate")}
                            value={formData.fromDateTime}
                            minDate={dayjs("1876-01-01")}
                            format="YYYY-MM-DD"
                            onChange={(event) => {
                                handleChange({ target: { name: "fromDateTime", value: event } });
                            }}
                            maxDate={formData.toDateTime}
                            sx={{
                                width: "100%",
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "green",
                                },
                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "green",
                                },
                            }}
                        />
                        <DesktopDatePicker
                            label={t("userSystem.endDate")}
                            value={formData.toDateTime}
                            format="YYYY-MM-DD"
                            onChange={(event) => {
                                handleChange({ target: { name: "toDateTime", value: event } });
                            }}
                            minDate={formData.fromDateTime || dayjs("1876-01-01")}
                            sx={{
                                width: "100%",
                                marginTop: "16px",
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "green",
                                },
                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "green",
                                },
                            }}
                        />
                    </LocalizationProvider>
                    <FormGroup>
                        <FormControlLabel
                            sx={{
                                "& .MuiFormControlLabel-label": {
                                    fontSize: "14px",
                                    color: "#000000de"
                                }
                            }}
                            control={<Checkbox
                                color="success"
                                name="isShowAll"
                                checked={formData.isShowAll}
                                onChange={handleChange}
                            />}
                            label={t("events.showSelected1876")}
                        />
                    </FormGroup>
                </div>
                <div className="my-[24px] ">
                    <p className="mb-[4px] mt-[0px] text-[13px]">{t("events.type")}</p>
                    <Accordion
                        expanded={expanded}
                        sx={{
                            boxShadow: "none",
                            backgroundColor: "transparent",
                            margin: "0!important",
                            '&::before': {
                                display: 'none',
                            }
                        }}>
                        <AccordionSummary
                            expandIcon={<IconButton onClick={() => setExpanded(expanded ? false : true)}>
                                <div className="material-icons">keyboard_arrow_right</div>
                            </IconButton>}
                            sx={{
                                padding: 0,
                                margin: "0!important",
                                minHeight: "34px!important",
                                height: "36px!important",
                                flexDirection: 'row-reverse',
                                '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                                    transform: 'rotate(90deg)',
                                },
                                '& .MuiAccordionSummary-content': {
                                    margin: "0!important",
                                },
                                '& .MuiTypography-root': {
                                    fontSize: "14px!important",
                                },
                                '&.Mui-expanded,': {
                                    minHeight: "34px"
                                },
                                '& .MuiAccordionSummary-content.Mui-expanded': {
                                    margin: "0!important",
                                }
                            }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="success"
                                        indeterminate={handleIndeterminate()}
                                        checked={formData.type.includes("Cyclone") && formData.type.includes("Winterstorm")}
                                        onChange={handleSelectAll}
                                        sx={{
                                            width: "36px",
                                            height: "36px",
                                            '& .MuiSvgIcon-root': {
                                                width: "22px!important",
                                                height: "22px!important",
                                            }
                                        }}
                                    />}
                                label={t("events.Storm")}
                            />

                        </AccordionSummary>
                        <AccordionDetails sx={{
                            padding: "0 0 0 48px",
                            width: "100%",
                            '& .MuiTypography-root': {
                                fontSize: "14px!important",
                            },
                        }}>
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox
                                        color="success"
                                        name="Cyclone"
                                        checked={formData.type.includes("Cyclone")}
                                        onChange={handleChange}
                                        sx={{
                                            width: "36px",
                                            height: "36px",
                                            '& .MuiSvgIcon-root': {
                                                width: "22px!important",
                                                height: "22px!important",
                                            }
                                        }}

                                    />}
                                    label={t("events.Cyclone")}
                                />
                                <FormControlLabel
                                    control={<Checkbox
                                        color="success"
                                        name="Winterstorm"
                                        checked={formData.type.includes("Winterstorm")}
                                        onChange={handleChange}
                                        sx={{
                                            width: "36px",
                                            height: "36px",
                                            '& .MuiSvgIcon-root': {
                                                width: "22px!important",
                                                height: "22px!important",
                                            }
                                        }}

                                    />}
                                    label={t("events.Winterstorm")}
                                />
                            </FormGroup>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        sx={{
                            boxShadow: "none",
                            backgroundColor: "transparent",
                            margin: "0!important",
                            '&::before': {
                                display: 'none',
                            }
                        }}>
                        <AccordionDetails sx={{
                            padding: "0 0 0 40px",
                            width: "100%",
                            '& .MuiTypography-root': {
                                fontSize: "14px!important",
                            },
                        }}>
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox
                                        color="success"
                                        name="Earthquake"
                                        checked={formData.type.includes("Earthquake")}
                                        onChange={handleChange}
                                        sx={{
                                            width: "36px",
                                            height: "36px",
                                            '& .MuiSvgIcon-root': {
                                                width: "22px!important",
                                                height: "22px!important",
                                            }
                                        }}

                                    />}
                                    label={t("events.Earthquake")}
                                />
                                <FormControlLabel
                                    control={<Checkbox
                                        color="success"
                                        name="Flood"
                                        checked={formData.type.includes("Flood")}
                                        onChange={handleChange}
                                        sx={{
                                            width: "36px",
                                            height: "36px",
                                            '& .MuiSvgIcon-root': {
                                                width: "22px!important",
                                                height: "22px!important",
                                            }
                                        }}

                                    />}
                                    label={t("events.Flood")}
                                />
                                <FormControlLabel
                                    control={<Checkbox
                                        color="success"
                                        name="Rainfall"
                                        checked={formData.type.includes("Rainfall")}
                                        onChange={handleChange}
                                        sx={{
                                            width: "36px",
                                            height: "36px",
                                            '& .MuiSvgIcon-root': {
                                                width: "22px!important",
                                                height: "22px!important",
                                            }
                                        }}

                                    />}
                                    label={t("events.Rainfall")}
                                />

                            </FormGroup>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </div>
            <div
                style={{
                    borderTop: '1px solid var(--gray-border)',
                    padding: '16px',
                    height: '64px',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Button
                    color="success"
                    disabled={handleRestDisable()}
                    onClick={() => {
                        setFormData({
                            ...formData,
                            fromDateTime: dayjs(new Date().setMonth(new Date().getMonth() - 3)),
                            toDateTime: dayjs(new Date()),
                            isShowAll: false,
                            type: ["Cyclone", "Winterstorm", "Earthquake", "Flood", "Rainfall"]
                        });
                    }}
                >
                    {t("buttons.reset")}
                </Button>
                <div>
                    <Button
                        color="success"
                        style={{ marginRight: '10px' }}
                        onClick={props.handleClose}>
                        {t("buttons.close")}
                    </Button>
                    <Button
                        variant="contained"
                        color="success"
                        disabled={handleApplyDisable()}
                        onClick={() => {
                            dispatch({
                                type: AppAction.setEventsFilterForm,
                                payload: {
                                    ...formData,
                                    fromDateTime: formData.fromDateTime.format("YYYY-MM-DD"),
                                    toDateTime: formData.toDateTime.format("YYYY-MM-DD"),
                                }
                            });
                            props.handleClose();
                        }}
                    >
                        {t("buttons.apply")}
                    </Button>
                </div>
            </div>
        </div>
    </Menu>);
}

export default FilterEvents;